// export var ip = "http://127.0.0.1:3033";
export var ip = "https://storevip-mini.shzskx.cn";